module.exports = __webpack_public_path__ + "img/img2.f370c701.png";